import { useMemo } from "react";
import ApproveDenyModal from ".";
import { useVisible } from "../../../../utils/hooks/useVisible"

export const useApproveDenyModal = ({ setData, setTotalItems, selectedStatus }) => {
    const { close, visible, selected, open } = useVisible();

    const modal = useMemo(() => {
        return (
            <ApproveDenyModal
                visible={visible}
                selected={selected}
                close={close}
                setData={setData}
                selectedStatus={selectedStatus}
                setTotalItems={setTotalItems}
            />
        );
    }, [close, setData, setTotalItems, selected, visible, selectedStatus]);

    return { open, modal };
}
